const PLATFORM_BRAND_NAME = 'RemoteBirdy';

export const getJobPosterLabel = (job) => {
  if (!job) return 'Company';

  if (job.is_managed_by_platform) {
    return `Managed by ${PLATFORM_BRAND_NAME}`;
  }

  if (job.company?.name) {
    return job.company.name;
  }

  const posterName = job.posted_by?.name || job.postedBy?.name;
  if (posterName) {
    return `Posted by ${posterName}`;
  }

  return 'Company';
};

export const shouldLinkJobPoster = (job) => {
  if (!job || job.is_managed_by_platform || job.company?.name) {
    return false;
  }

  return !!(job.posted_by?.username || job.postedBy?.username);
};

export const getJobPosterUsername = (job) => {
  return job?.posted_by?.username || job?.postedBy?.username || null;
};

export const getJobCompanyNameForMeta = (job) => {
  if (job?.is_managed_by_platform) {
    return PLATFORM_BRAND_NAME;
  }

  return job?.company?.name || job?.posted_by?.name || job?.postedBy?.name || 'Company';
};
